import type { Member } from '~/shared/types/member'

/** Whether the member holds a completed VIP ticket for the given parade year. */
export function hasVipTicket(member: Pick<Member, 'purchases'>, year: number | string): boolean {
  const vip = member.purchases?.[String(year)]?.vip
  return Array.isArray(vip) && vip.some(p => p.status === 'completed')
}

/** The member's admin roles as admins name them, broadest first. */
export function adminRoleLabels(member: Pick<Member, 'roles'>): string[] {
  const labels: string[] = []
  if (member.roles?.admin) labels.push('Global')
  if (member.roles?.band_admin) labels.push('Band')
  if (member.roles?.redshirt_admin) labels.push('Red Shirt')
  return labels
}
